import { Users, Gift, Clock } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { CarregandoLista } from "@/components/carregando";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

const dataBr = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString("pt-BR");
};

/**
 * Cada indicado com o estagio do premio. A coluna da direita e' a que importa:
 * separa "ja me rendeu os meses" de "cadastrou mas ainda nao pagou" — sem ela o
 * lojista nao entende por que indicou 3 e so' ganhou 1 premio.
 */
export default function ListaIndicados({ indicados, mesesPorIndicacao, loading }) {
  if (loading) return <CarregandoLista linhas={3} colunas={2} />;

  if (!indicados?.length) {
    return (
      <div className="rounded-2xl border bg-card p-10 text-center">
        <div className="w-14 h-14 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
          <Users className="w-7 h-7 text-muted-foreground" />
        </div>
        <h3 className="font-semibold mb-1">Você ainda não indicou ninguém</h3>
        <p className="text-sm text-muted-foreground max-w-sm mx-auto">
          Compartilhe seu código com outros estabelecimentos. Assim que o
          primeiro deles pagar a mensalidade inicial, seus {mesesPorIndicacao}{" "}
          meses grátis aparecem aqui.
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border bg-card overflow-hidden">
      <div className="px-5 py-4 border-b">
        <h2 className="font-semibold">Seus indicados</h2>
      </div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Estabelecimento</TableHead>
              <TableHead>Indicado em</TableHead>
              <TableHead className="text-right">Seu prêmio</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {indicados.map((r) => (
              <TableRow key={r.id}>
                <TableCell>
                  <p className="font-medium">{r.name}</p>
                  <p className="text-xs text-muted-foreground">{r.slug}</p>
                </TableCell>
                <TableCell className="text-muted-foreground text-sm">
                  {dataBr(r.created_at)}
                </TableCell>
                <TableCell className="text-right">
                  {r.premiado ? (
                    <Badge className="bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30 hover:bg-emerald-500/15">
                      <Gift className="w-3 h-3 mr-1" />
                      +{r.meses_ganhos} meses
                    </Badge>
                  ) : (
                    <Badge variant="outline" className="text-muted-foreground">
                      <Clock className="w-3 h-3 mr-1" />
                      Aguardando 1º pagamento
                    </Badge>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
